import {isMobile} from "../libs/mobile-tools";
import {countLines} from "../libs/text-tools";
import mobileDrawer from "../libs/mobileDrawer";
import simpleModal from "../libs/simpleModal";

export default context => {
    const appendix = translate.readmore
    if (isMobile()) {
        $('.readmore > div:first-child', context).each(function () {
            if (countLines(this) > 2) {
                const container = this
                $(`<a href="#" class="readmore-btn">${appendix}</a>`)
                    .on('click', function () {
                        const buttons = $('.share-buttons.mobile-hide').clone()
                        mobileDrawer(
                            'ReadMoreDrawer',
                            container.innerHTML + `<div class="share-buttons">${buttons.html()}</div>`
                        )
                        return false
                    }).insertAfter(container)
            }
        })
    } else {
        $('.readmore > div:first-child', context).each(function () {
            if (countLines(this) > 3) {
                const container = this
                $(container).addClass('readmore-text');
                $(`<div class="readmore-link"><a href="#" class="readmore-btn">${appendix}</a></div>`)
                    .on('click', function () {
                        const modal = new simpleModal({
                            id: 'ReadMoreModal',
                            content: `
                                <img class="cover-image" src="${community.cover}">
                                <h2 id="ReadMoreModal__title">${community.title}</h2>
                                <div class="description">${container.innerHTML}</div>
                                <button type="button">${translate.close_btn}</button>
                            `,
                        })
                        modal.$.find('.window-body > button').on('click', () => modal.hide())
                        modal.show()
                        return false
                    })
                    .insertAfter(container)
            }
        })
    }
}
